import React from 'react';
import Footer from '../Footer';
import './styles/ContactPage.css';

const VENUE_ADDRESS = 'Klisovác u. 19, 2011 Budakalász, Magyarország';
const MAP_EMBED_SRC = `https://www.google.com/maps?q=${encodeURIComponent(VENUE_ADDRESS)}&hl=hu&z=16&output=embed`;
const MAIN_PHONE = '+36 26 541 000';
const MAIN_PHONE_TEL = '+3626541000';

const PHONE_MENU_OPTIONS = [
  { key: '1', text: 'elhelyezéssel kapcsolatos információk' },
  { key: '2', text: 'egészségügyi információk az otthon lakóiról' },
  { key: '3', text: 'havi díjjal, befizetésekkel kapcsolatos információk' },
  { key: '4', text: 'beszerzéssel, munkaügyekkel kapcsolatos információk' },
  { key: '5', text: 'programszervezés, mentálhigiénés csoport' },
  { key: '0', text: 'a menü ismételt meghallgatása', isReplay: true },
];

const ContactPage = () => {
  const replayOption = PHONE_MENU_OPTIONS.find((o) => o.isReplay);

  return (
    <div className="contact-page">
      <div className="contact-container">
        <header className="contact-header">
          <span className="contact-page-icon" aria-hidden>📬</span>
          <div>
            <h1>Elérhetőségek</h1>
            <p>Vegye fel velünk a kapcsolatot! Szívesen válaszolunk minden kérdésére.</p>
          </div>
        </header>

        <div className="contact-content">
          <div className="contact-info-section">
            <div className="contact-sidebar-card">
              <div className="card-header">
                <span className="card-icon">🏢</span>
                <h3>Napvirág Idősek Otthona</h3>
              </div>

              <div className="contact-details-compact">
                <p className="contact-detail-row contact-detail-row--address">
                  <span className="detail-icon" aria-hidden>📍</span>
                  <span>
                    <strong>Cím:</strong> {VENUE_ADDRESS}
                  </span>
                </p>
                <p className="contact-detail-row">
                  <span className="detail-icon" aria-hidden>📞</span>
                  <span>
                    <strong>Telefon:</strong>{' '}
                    <a href={`tel:${MAIN_PHONE_TEL}`} className="contact-phone-link">
                      {MAIN_PHONE}
                    </a>
                  </span>
                </p>
                <p className="contact-detail-row">
                  <span className="detail-icon" aria-hidden>📧</span>
                  <span>
                    <strong>Email:</strong>{' '}
                    <a href="mailto:napviragotthon@napviragotthon.hu" className="contact-email-link">
                      napviragotthon@napviragotthon.hu
                    </a>
                  </span>
                </p>
              </div>

              <div className="contact-sidebar-divider" role="presentation" />

              <div className="phone-menu-section">
                <div className="phone-menu-header">
                  <span className="card-icon phone-menu-icon" aria-hidden>☎️</span>
                  <div>
                    <h4>Telefonközpont menü</h4>
                    <p className="phone-menu-subtitle">
                      Elérhető hétfőtől péntekig, irodai munkarendben
                    </p>
                  </div>
                </div>
                <ul className="phone-menu-grid">
                  {PHONE_MENU_OPTIONS.filter((o) => !o.isReplay).map((option) => (
                    <li key={option.key} className="phone-menu-item">
                      <span className="phone-menu-key" aria-hidden>
                        {option.key}
                      </span>
                      <span className="phone-menu-text">{option.text}</span>
                    </li>
                  ))}
                </ul>
                <div className="phone-menu-footer">
                  <p className="phone-menu-replay">
                    <span className="phone-menu-key phone-menu-key--muted" aria-hidden>
                      0
                    </span>
                    <span className="phone-menu-text">{replayOption.text}</span>
                  </p>
                  <p className="phone-menu-notice">Minőségbiztosítási okokból hívását rögzítjük!</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-map-section">
            <section className="contact-map-row contact-map-row--primary" aria-labelledby="contact-map-heading">
              <h3 id="contact-map-heading">Helyszín</h3>
              <div className="map-container">
                <iframe
                  title="Napvirág Idősek Otthona – Budakalász"
                  src={MAP_EMBED_SRC}
                  className="map-embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
